export default "__VITE_ASSET__BYglAxem__"